import { useQuery } from "@apollo/client";

import { Maybe } from "types/generated";

import { GET_GITLAB_INTEGRATION } from "./gql";

const useGetGitLabIntegration = (id: Maybe<string>) => {
  const { data, loading, error } = useQuery(GET_GITLAB_INTEGRATION, {
    variables: {
      id,
    },
    fetchPolicy: "no-cache",
  });

  return {
    integration: data?.gitlabIntegration,
    isPageLoading: loading && !data?.gitlabIntegration,
    error,
  };
};

export default useGetGitLabIntegration;
